<template>
    <section :id="'inverter-result' + item">
        <SectionHeader
            :heading="heading"
            :completed="completed"
            :to-complete="toComplete"
        />

        <SectionGroup
            v-for="(field, index) in data.mppts"
            :id="item + 'mppt' + index"
            :key="index"
            :heading="field.label"
            :validated.sync="validated[index]"
        >
            <template #default="{ validate }">
                <div class="field--full flex-b">
                    <div class="commissioning-sheet__tag small semi">
                        <span>Voc</span>
                        <Tooltip text="Refer to the nameplate" position="right" />
                    </div>
                    <div class="commissioning-sheet__tag small semi">
                        <span>Isc</span>
                        <Tooltip text="Refer to the nameplate" />
                    </div>
                </div>

                <InputField placeholder="00" label="VOC" name="pvModelVoc" type="number" readonly required :value.sync="data.mppts[index].pvModelVoc" step=".01" unit="V" @validate="validate" />
                <InputField placeholder="00.00" label="ISC" name="pvModelIsc" type="number" readonly required :value.sync="data.mppts[index].pvModelIsc" unit="A" @validate="validate" />

                <div class="field--full mt-lg">
                    <div class="commissioning-sheet__tag small semi">
                        <span>PV Array Maximum Voltage</span>
                        <Tooltip text="Refer to AS/NZS 5033" position="right" />
                    </div>
                </div>

                <InputField placeholder="0000" label="PVAMV" name="pvamv" type="number" readonly required :value.sync="data.mppts[index].pvamv" unit="V" @validate="validate" />

                <div class="field--full mt-lg">
                    <div class="commissioning-sheet__tag small semi">
                        <span>Measured</span>
                        <Tooltip text="Refer to AS/NZS 5033 for correct testing procedures" position="right" />
                    </div>
                </div>

                <CheckboxGroup required>
                    <CheckboxField label="Correct polarity" :value.sync="data.mppts[index].correctPolarity" unit="Ω" @validate="validate" />
                </CheckboxGroup>

                <InputField placeholder="00.00" label="Earth Continuity" name="earthContinuity" type="number" required :value.sync="data.mppts[index].earthContinuity" unit="Ω" @validate="validate" />
                <InputField placeholder="0.0" label="Insulation Resistance -Ve to E" name="insulationResistanceMinus" type="number" required :value.sync="data.mppts[index].insulationResistanceMinus" unit="MΩ" @validate="validate" />
                <InputField placeholder="0.0" label="Insulation Resistance +Ve to E" name="insulationResistancePlus" type="number" required :value.sync="data.mppts[index].insulationResistancePlus" unit="MΩ" @validate="validate" />
                <InputField placeholder="0000.00" label="Voc" name="measuredVoc" type="number" required :value.sync="data.mppts[index].measuredVoc" unit="V" @validate="validate" />
                <InputField placeholder="000.00" label="ISC" name="measuredIsc" type="number" :value.sync="data.mppts[index].measuredIsc" unit="A" />
                <InputField placeholder="0000" label="Irrad" name="measuredIrrad" type="number" :value.sync="data.mppts[index].measuredIrrad" unit="W/m2" />
                <InputField placeholder="0000.00" label="Vmp" name="measuredVmp" type="number" required :value.sync="data.mppts[index].measuredVmp" unit="V" @validate="validate" />
                <InputField placeholder="000.00" label="Imp" name="measuredImp" type="number" required :value.sync="data.mppts[index].measuredImp" unit="A" @validate="validate" />
            </template>
        </SectionGroup>
    </section>
</template>
<script>
import Tooltip from '@/components/Tooltip';
import InputField from './InputField';
import CheckboxGroup from './CheckboxGroup';
import CheckboxField from './CheckboxField';
import SectionHeader from './SectionHeader';
import SectionGroup from './SectionGroup';

export default {
    components: {
        SectionHeader,
        SectionGroup,
        InputField,
        CheckboxGroup,
        CheckboxField,
        Tooltip
    },

    props: {
        heading: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
        item: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            validated: [],
        };
    },

    computed: {
        completed() {
            return this.validated.filter(item => item === true).length;
        },
        toComplete() {
            return this.data.mppts.length;
        },
    },

    watch: {
        completed() {
            this.$emit('update:validated', this.completed === this.toComplete);
            this.$emit('status', this.completed, this.item);
        },
    },

    created() {
        const validated = [];
        this.data.mppts.map(() => {
            validated.push(false);
        });

        this.validated = validated;

        this.$emit('tocomplete', this.toComplete, this.item);
    },
}
</script>
